import { render } from "./ObservationsModalGom.vue?vue&type=template&id=d95f699e&scoped=true"
import script from "./ObservationsModalGom.vue?vue&type=script&lang=js"
export * from "./ObservationsModalGom.vue?vue&type=script&lang=js"

import "./ObservationsModalGom.vue?vue&type=style&index=0&id=d95f699e&scoped=true&lang=less"
import "./ObservationsModalGom.vue?vue&type=style&index=1&id=d95f699e&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d95f699e"]])

export default __exports__